// extracted by mini-css-extract-plugin
export default {"controls":"StorageSection_controls__BD+8L","placeHolderShimmer":"StorageSection_placeHolderShimmer__nXAb4"};